<!--
Author: TangChen
Date: 2018-10-31
Desc: 风险评测管理组件，由index.js 配置引入
-->
<template>
    <div :class="'view-risk view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row>
            <el-col :span="24" class="risklevel">
                您的风险等级： <span>{{ !$util.isEmpty(info.custrisk)?$cache.getDict('100017',info.custrisk):'未做风险评测' }}</span>
            </el-col>
            <el-col :span="24">
                <div class="risk-msg">
                    <div v-if="riskInfo" class="lineF clear">
                        <div v-for="(btn,index) in riskInfo" :key="index" class="boxF">
                            <div class="boxS" :class="notIE9?'':'ie-low'">
                                <div class="boxT" :class="btn.tit===info.custrisk?'yel':(Number(btn.tit-1)===Number(info.custrisk)?'blue':'')">
                                    <div class="overlay">
                                        <span>{{ $cache.getDict('100017',btn.tit) }}</span>
                                        <p>对应{{ $cache.getDict('110143',btn.tit) }}风险产品</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="info.custrisk" class="risk-info">
                        {{ !$util.isEmpty(info.custrisk)?$util.getRiskTest(info.custrisk):"未做风险测评" }}
                    </div>
                </div>
            </el-col>
            <el-col :span="24" class="risk-other">
                <div class="btn-group">
                    <el-button type="primary" v-on:click.once="$router.push({name:'risktest'})">
                        {{ !$util.isEmpty(info.custrisk)?"重新":"立即" }}测评
                    </el-button>
                    <el-button v-if="!$util.isEmpty(info.custrisk)" class="border-blue" v-on:click="continueRisk">
                        沿用上次风测
                    </el-button>
                </div>
                <div class="btn-group pt20">
                    <el-button class="medium" v-on:click="$router.push({name:'orginfo'})">
                        返回
                    </el-button>
                </div>
                <p>为了便于金融机构更好地为您提供适当性服务，请您</p>
                <span class="like-a" v-on:click.once="$router.push({name:'infocollection'})">前往信息补录</span>
            </el-col>
        </el-row>
        <el-dialog title="风险评测提示" :visible.sync="dialogVisible" class="prop" width="420px">
            <div class="info-box">
                <el-alert
                    title="由于您的风险等级发生调整，系统需要您对已签订的定期投资协议或预约交易进行适当性处理，对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。"
                    type="warning"
                    show-icon
                    :closable="false"
                />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click.once="$router.push({name:'home'})">
                    前往处理
                </el-button>
                <el-button v-on:click="dialogVisible = false">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "Risk",
    mixins: [mixin],
    data () {
        return {
            notIE9: true,
            info: {},
            riskInfo: [{
                tit: "01"
            }, {
                tit: "02"
            }, {
                tit: "03"
            }, {
                tit: "04"
            }, {
                tit: "05"
            }],
            iswarn: "",
            dialogVisible: false
        };
    },
    created () {
        const theUA = window.navigator.userAgent.toLowerCase();
        if ((theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) || (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])) {
            const ieVersion = theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] || theUA.match(/trident\s?\d+/)[0];
            if (ieVersion === "9") {
                this.notIE9 = false;
            }
        }
        this.info = this.$cache.getUser();
        this.iswarn = this.$route.query.iswarn || "";
        this.riskAgree();
    },
    methods: {
        // 协议弹窗处理
        riskAgree (flag) {
            let _this=this
            if (this.iswarn === "1") {
                this.dialogVisible = true;
            }else {
                if(flag===undefined)return
                this.$message({
                    type: "success",
                    message: "风险设置成功，3秒后自动跳转至信息中心页面"
                });
                setTimeout(function () {
                    _this.$router.push({name:'orginfo'})
                },3000)
            }
        },
        // 风险沿用
        continueRisk () {
            const _this = this;
            this.$util.request("acct/risksurvey/answer", { iscontinue: "0" }, "POST").then(res => {
                if (res.data) {
                    _this.$message({
                        type: "success",
                        message: "风险评测结果沿用成功"
                    });
                    const info = _this.$cache.getUser();
                    info.riskexpired = "0";
                    info.custrisk = res.data[0].risklevel;
                    _this.$store.dispatch("setInfo", info).then(() => {
                        _this.iswarn = res.data[0].iswarn;
                        _this.riskAgree(1);
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.view-risk {
    padding-bottom: 50px;
    .risklevel {
        font-size: $f16;
        color: $text-color1;
        text-align: center;
        line-height: 50px;
        margin-top: 30px;
        span {
            font-size: $f22;
            color: $color-b;
        }
    }
    .risk-info {
        font-size: $f16;
        color: $text-color1;
        line-height: 24px;
        margin-top: 20px;
    }
    .risk-msg {
        position: relative;
        width: 1026px;
        margin: 20px auto 46px;
        .boxF,
        .boxS,
        .boxT,
        .overlay {
            width: 208px;
            height: 240px;
            overflow: hidden;
        }
        .overlay {
            padding: 82px 32px 40px;
        }
        .boxF:not(:first-child) .boxT {
            &:before,
            &:after {
                top: -1px;
                border-bottom: 46px solid $border-color4;
                border-left-width: 23px;
                border-right-width: 23px;
            }
        }
        .boxF .boxT {
            background-color: $bg15;
            &.yel {
                background-color: $color-b;
                &:before,
                &:after {
                    border-bottom-color: $color-a-s;
                }
            }
            &.blue {
                &:before,
                &:after {
                    border-bottom-color: $bg8;
                }
            }
        }
    }
    .risk-other {
        text-align: center;
        line-height: 30px;
        .el-button {
            width: 150px;
            &.border-blue {
                border-color: $color-b;
                color: $color-b;
            }
        }
        .el-button + .el-button {
            margin-left: 24px;
        }
        p {
            color: $text-color1;
            margin-top: 40px;
        }
    }
    .pt20{
        padding-top:20px;
    }
}
</style>
